import React, { Component } from 'react'

import slider1 from '../image/slider1.png'
export class SliderComp extends Component {
  render() {
    const {image, span1, span2, width, width2} = this.props;
    //  slide-show-cont
    return (
        <div className='max-h-[720px] relative  min-w-[100%] transition'>
          <img  className='w-full min-h-[400px] max-[730px]:min-h-[300px]' src={image}  />
          <div className='flex absolute inset-0 z-10 justify-end max-[600px]:justify-center items-center h-full container slide-show-cont'>

            <div className='p-[48px] bg-[#ffffff5e] max-[1026px]:p-[30px] rounded-[8px] flex flex-col gap-[8px] 
            max-w-[80%]  items-end max-[1360px]:mr-[50px] max-[1260px]:mr-[100px] max-[900px]:p-[25px] max-[900]:mt-[10%]
             max-[600px]:max-w-[90%] max-[600px]:mr-0  max-[600px]:mt-[10%]   max-[600px]:items-center  max-[380px]:mt-[52%] max-[380px]:max-w-[100%]
            '>
              <span className= {`${width}  text-[white] text-end text-[48px] leading-[60px] font-[900] 
                max-[1026px]:text-[36px] max-[1026px]:leading-[48px] max-[700px]:text-[24px] max-[700px]:leading-[26px]`}>
                {span1}
              <br />
              </span>
              <span className={`${width2} text-[#467C7C] text-end text-[48px] leading-[60px] font-[900] 
                max-[1026px]:text-[36px] max-[1026px]:leading-[48px]  max-[700px]:text-[24px] max-[700px]:leading-[26px] max-[380px]:text-[20px]`} >
                {span2}
              </span>
            </div>
          </div>
        </div>
    )
  }
}

export default SliderComp